package learning.components

import antd.badge.badge
import antd.button.button
import antd.form.formItem
import antd.grid.row
import antd.icon.deleteOutlined
import antd.icon.editOutlined
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.modal.ModalComponent
import antd.modal.modal
import antd.switch.switch
import antd.select.SelectComponent
import antd.select.optGroup
import antd.select.option
import antd.select.select
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.common.orm.mapping.Comment
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.content.model.ContentVo
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import external.select.filterOptionFun
import kotlinx.browser.document
import kotlinx.html.unsafe
import learning.containers.ShangHanLunReadingPageContext
import org.w3c.dom.HTMLScriptElement
import react.*
import react.dom.*
import antd.form.form
import antd.grid.col
import antd.input.input
import antd.layout.space
import com.jingfangpai.common.data.model.Result
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionEntityType
import com.jingfangpai.contentEntity.model.ContentConnectionDto
import kotlinext.js.Object
import kotlinext.js.js
import org.w3c.dom.HTMLElement
import kotlinx.browser.window
import urlBase
import antd.icon.linkOutlined
import antd.radio.radioGroup
import com.jingfangpai.common.orm.mapping.Feedback
import com.jingfangpai.common.orm.mapping.enums.ContentConnectionRelationType
import com.jingfangpai.common.orm.mapping.enums.FeedbackType
import external.toJsObject
import kotlinext.js.jsObject
import kotlin.collections.map
import user.service.AuthService

external interface ShangHanLunItemProps : RProps {
    var keyword:String
    var content:ContentVo
    var itemIndex:Int
    var bookId:String
    //var comments: Map<String, CommentVo>
    var signSymptoms:Array<CascadedOption<String>>
    var onSaveConnection:(itemIndex:Int,contentConnection:ContentConnectionDto,callback:(Result)->Unit)->Unit
    var onConnectionRemoved:(itemIndex:Int,contentConnection:ContentConnectionDto,callback:(Result)->Unit)->Unit
    var onEditAnnotation: ((comment: Comment, contentId: String) -> Unit)?
    var onDeleteAnnotation: ((comment: Comment, contentId: String) -> Unit)?
}

val ShangHanLunItem = functionalComponent<ShangHanLunItemProps> { props ->

    val (contentMatched,setContentMatched) = useState(setOf<String>())
    val (commentMatched,setCommentMatched) = useState(setOf<String>())
    val (commentsInvisible,setCommentsInvisible) = useState(setOf<String>())
    val (contentConnection,setContentConnection) = useState(ContentConnectionDto())
    val (showConnectModal,setShowConnectModal) = useState(false)
    val (currentContent,setCurrentContent) = useState(ContentVo())
    val pageCtx = useContext(ShangHanLunReadingPageContext)
    
    // Note modal state
    val (showNoteModal, setShowNoteModal) = useState(false)
    val (editingNote, setEditingNote) = useState<Comment?>(null)
    val (noteForm, setNoteForm) = useState(Comment())
    val (saving, setSaving) = useState(false)
    val (saveError, setSaveError) = useState<String?>(null)
    val (editorScriptLoaded, setEditorScriptLoaded) = useState(false)
    val (noteEditor, setNoteEditor) = useState<CKEditor?>(null)
    val (noteTargetContentId, setNoteTargetContentId) = useState<String>("")
    // notes map: contentId -> Array<Comment>
    val (notesMap, setNotesMap) = useState(mapOf<String, Array<Comment>>())
    
    // CKEditor Base64 image upload adapter
    val configureBase64Upload = js("""
function(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = function(loader) {
        return {
            upload: function() {
                return loader.file.then(function(file) {
                    return new Promise(function(resolve) {
                        var reader = new FileReader();
                        reader.onload = function() { resolve({ 'default': reader.result }); };
                        reader.readAsDataURL(file);
                    });
                });
            }
        };
    };
}
""").unsafeCast<(dynamic) -> Unit>()
    
    // Load CKEditor script once (global singleton to avoid duplicated-modules error)
    useEffectOnce {
        if (js("typeof ClassicEditor !== 'undefined'").unsafeCast<Boolean>()) {
            setEditorScriptLoaded(true)
        } else if (document.getElementById("ckeditor-script-global") != null) {
            setEditorScriptLoaded(true)
        } else {
            val s = document.createElement("script") as HTMLScriptElement
            s.src = "/ckeditor.js"
            s.id = "ckeditor-script-global"
            document.body?.appendChild(s)
            s.onload = {
                setEditorScriptLoaded(true)
            }
        }
    }
    
    // Initialize / cleanup editor when modal visibility changes
    useEffect(showNoteModal, editorScriptLoaded) {
        if (showNoteModal && editorScriptLoaded) {
            js("setTimeout")({
                val el = document.querySelector("#note-editor-shanghanlun")
                if (el != null) {
                    val config = jsObject<EditorConf> {
                        toolbar = jsObject<EditorToolbarConf> {
                            items = arrayOf(
                                "bold", "italic", "underline",
                                "fontSize", "fontColor", "link",
                                "bulletedList", "numberedList",
                                "|",
                                "outdent", "indent",
                                "|",
                                "imageUpload", "blockQuote",
                                "undo", "redo"
                            )
                        }
                        language = "zh-cn"
                        licenseKey = ""
                    }
                    ClassicEditor.create(el, config)
                        .then { editor: dynamic ->
                            configureBase64Upload(editor)
                            setNoteEditor(editor.unsafeCast<CKEditor>())
                            noteForm.comment?.let { data ->
                                editor.setData(data)
                            }
                            editor.model.document.on("change:data") { _: dynamic, _: dynamic ->
                                val newComment = editor.getData() as String
                                setNoteForm { currentNote ->
                                    Object.assign(Comment(), currentNote).apply {
                                        comment = newComment
                                    }
                                }
                            }
                        }
                        .catch { error: dynamic ->
                            console.error("CKEditor init failed:", error)
                        }
                }
            }, 150)
        }
    }
    
    fun destroyNoteEditor() {
        noteEditor?.let { editor ->
            try {
                editor.asDynamic().destroy()
            } catch (e: dynamic) {
                console.log("Editor destroy error:", e)
            }
        }
        setNoteEditor(null)
        // Clear residual content in the editor div so next open starts fresh
        val el = document.querySelector("#note-editor-shanghanlun")
        if (el != null) {
            el.innerHTML = ""
        }
    }
    
    fun openAddNoteModal(contentId: String) {
        setEditingNote(null)
        setSaveError(null)
        setNoteTargetContentId(contentId)
        setNoteForm(Comment().apply {
            entityType = CommentEntityType.Content
            entityId = contentId
            type = CommentType.笔记
            authorId = AuthService.getUserAuthData()?.id ?: ""
            createdBy = AuthService.getUserAuthData()?.userName ?: ""
            weight = 0
        })
        setShowNoteModal(true)
    }

    // Fetch notes for the entire book (single batch call)
    fun fetchNotes() {
        val authorId = AuthService.getUserAuthData()?.id ?: ""
        pageCtx.fetchBookComments(CommentType.笔记, props.bookId, authorId, { resp ->
            if (resp.ok() && resp.data != null) {
                // Group notes by entityId (contentId)
                val grouped = resp.data!!.groupBy { it.entityId ?: "" }
                    .mapValues { it.value.toTypedArray() }
                setNotesMap(grouped)
            }
        }, {
            console.error("获取笔记失败:", it)
        })
    }
    
    fun saveNote() {
        val editorComment = noteEditor?.asDynamic()?.getData() as? String
        val commentToSave = editorComment ?: noteForm.comment
        
        if (commentToSave.isNullOrBlank()) {
            setSaveError("请填写笔记内容")
            return
        }
        
        val finalNote = Object.assign(Comment(), noteForm).apply {
            comment = commentToSave
            entityType = CommentEntityType.Content
            entityId = noteTargetContentId
            type = CommentType.笔记
            authorId = AuthService.getUserAuthData()?.id ?: ""
        }
        
        if (finalNote.createdOn == null) {
            finalNote.createdOn = DateTime()
        }
        
        setSaving(true)
        setSaveError(null)
        destroyNoteEditor()
        pageCtx.saveComment(finalNote, { resp ->
            setSaving(false)
            if (resp.ok()) {
                // Refresh all notes for this book (batch)
                fetchNotes()
                setShowNoteModal(false)
                setNoteForm(Comment())
                setEditingNote(null)
            } else {
                setSaveError("抱歉，出错了：${resp.message}")
            }
        }, {
            setSaving(false)
            console.log(it)
            setSaveError("保存失败，${it.message}")
        })
    }
    fun onSaveConnection(event:antd.MouseEvent<HTMLElement>){
        if (contentConnection.isDeleted) {
            ModalComponent.confirm(jsObject {
                title = "确认删除"
                content = "确定要删除这条关联吗？"
                okText = "删除"
                cancelText = "取消"
                onCancel = {
                    ModalComponent.destroyAll()
                }
                okType = "danger"
                onOk = { _: dynamic ->
                    val _contentConnection = Object.assign(ContentConnectionDto(), contentConnection)
                    _contentConnection.isDeleted = true
                    setContentConnection(_contentConnection)
                    props.onSaveConnection(props.itemIndex, _contentConnection) { result ->
                        if (result.ok()) {
                            props.onConnectionRemoved(props.itemIndex, _contentConnection) {}
                            setShowConnectModal(false)
                            ModalComponent.destroyAll()
                        } else {
                            message.error(result.message ?: "")
                        }
                    }
                }
            })
        } else {
            props.onSaveConnection(props.itemIndex, contentConnection) { result ->
                if (result.ok()) {
                    setShowConnectModal(false)
                } else {
                    message.error(result.message ?: "")
                }
            }
        }
    }



    useEffectOnce {
        var _titleMatched = mutableSetOf<String>()
        var _commentMatched = mutableSetOf<String>()
        props.content.children?.let{ children->
            children.forEachIndexed { index, contentVo ->
                //val commentVo = commentMap[contentVo.id]
                var titleContainsKey = false;
                //var commentContainsKey = false;
                if(!props.keyword.isNullOrBlank()){
                    titleContainsKey = contentVo.content?.contains(props.keyword)?:false
                    //commentContainsKey = !contentVo?.comment?.comment.isNullOrBlank() && commentVo?.comment?.comment!!.contains(props.keyword)
                }
                //var show = props.keyword == "" || titleContainsKey || commentContainsKey;
                if(titleContainsKey) _titleMatched.add(contentVo.id?:"")
                //if(commentContainsKey) _commentMatched.add(contentVo.id?:"")
            }
            setContentMatched(_titleMatched)
            //setCommentMatched(_commentMatched)
        }
        // Fetch notes for all children
        fetchNotes()
    }

    div("ShangHanLunItem") {
        val itemVisiable = props.keyword.isNotBlank() || props.content.title?.contains(props.keyword)?:false
        if(itemVisiable || contentMatched.isNotEmpty() || commentMatched.isNotEmpty()){

            list<ContentVo, ListComponent<ContentVo>> {
                attrs {
                    itemLayout = "horizontal"
                    dataSource = props.content.children
                    header = buildElement {
                        h3 {
                            +"${props.content.title}"
                        }
                    }
                    renderItem = { item, index ->

                        val contentContainsKey = contentMatched.contains(item.id)
                        val commentContainsKey = commentMatched.contains(item.id)
                       // val comment = commentMap[item.id]?.comment?.comment?:""
                        listItem {
                            attrs{
                                /*actions = arrayOf(
                                    buildElement {
                                        a {
                                          attrs{
                                              onClickFunction = {
                                                  setContentConnection(ContentConnectionDto().apply {
                                                      contentId = item.id
                                                      entityType = ContentConnectionEntityType.SignSymptom
                                                      createdOn = DateTime()
                                                  })
                                                  setCurrentContent(item)
                                                  setShowConnectModal(true)
                                              }
                                          }
                                             +"+关联"
                                        }
                                    }!!,
                                    buildElement {
                                        a {
                                            attrs{
                                                onClickFunction = {
                                                    message.info("功能正在开发中")
                                                }
                                            }
                                        +"+注释"
                                    }
                                   }!!
                                )*/
                            }
                            listItemMeta {
                                attrs {
                                    key = "${item.id}"
                                    id = "${item.id}"
                                    className = if(props.keyword.isNotBlank() || contentContainsKey || commentContainsKey) "" else "hidden"

                                    avatar = buildElement {
                                        badge{
                                            attrs{
                                                overflowCount = 1000
                                                count = item.index
                                            }
                                        }
                                    }
                                    title = buildElement {
                                        div{
                                            h3{
                                                attrs {
                                                    unsafe {
                                                        + "${item.content}"
                                                    }
                                                    jsStyle = js{
                                                        display = "inline-block"
                                                    }
                                                }
                                            }
                                            child(ContentConnectionComponent){
                                                attrs{
                                                    connections = item.connections
                                                    wrapperStyle = js{
                                                        display = "inline-block"
                                                    }
                                                    onTagClick = { entityId, entityName, entityType, relationType, connectionId ->
                                                        setContentConnection(ContentConnectionDto().apply {
                                                            id = connectionId
                                                            contentId = item.id
                                                            this.entityId = entityId
                                                            this.entityName = entityName
                                                            this.entityType = entityType
                                                            this.relationType = relationType
                                                            createdOn = DateTime()
                                                        })
                                                        setCurrentContent(item)
                                                        setShowConnectModal(true)
                                                    }
                                                }
                                            }
                                            div("actions"){
                                                attrs{
                                                    jsStyle = js{
                                                        display = "inline-block"
                                                        paddingLeft = "10px"
                                                    }
                                                }
                                                space{
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            type = "link"
                                                            icon = buildElement { linkOutlined {} }
                                                            onClick = {
                                                                item.id?.let { contentId ->
                                                                    window.open("$urlBase/learning/shanghanlun/detail/$contentId", "_blank")
                                                                }
                                                            }
                                                        }
                                                    }
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            onClick = {
                                                                setContentConnection(ContentConnectionDto().apply {
                                                                    contentId = item.id
                                                                    entityType = ContentConnectionEntityType.SignSymptom
                                                                    relationType = ContentConnectionRelationType.相关
                                                                    createdOn = DateTime()
                                                                })
                                                                setCurrentContent(item)
                                                                setShowConnectModal(true)
                                                            }
                                                        }
                                                        +"+关联"
                                                    }
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            onClick = {
                                                                message.info("功能正在开发中")
                                                            }
                                                        }
                                                        +"+注释"
                                                    }
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            onClick = {
                                                                item.id?.let { openAddNoteModal(it) }
                                                            }
                                                        }
                                                        +"+笔记"
                                                    }
                                                }
                                            }
                                        }
                                        /*button {
                                            attrs{
                                                onClick = {
                                                    //toggleComment(item.id)
                                                }
                                            }
                                            if(contentContainsKey) reactStringReplace(item.content?:"", props.keyword, { match, i-> buildElement { em { +match } } }) else span{
                                               + "${item.content}"
                                            }
                                        }*/
                                    }
                                    description = buildElement {
                                        div{
                                            // Show inline comments
                                            if(item.comments != null){
                                                item.comments.forEach { comment->
                                                    div("comment-${comment.id}"){
                                                        attrs.jsStyle = js {
                                                            position = "relative"
                                                        }
                                                        div {
                                                            attrs.unsafe {
                                                                +"${comment.comment?:""}"
                                                            }
                                                        }
                                                        if (props.onEditAnnotation != null || props.onDeleteAnnotation != null) {
                                                            div {
                                                                attrs.jsStyle = js {
                                                                    display = "inline-flex"
                                                                    gap = "4px"
                                                                    marginLeft = "8px"
                                                                }
                                                                props.onEditAnnotation?.let { onEdit ->
                                                                    button {
                                                                        attrs {
                                                                            type = "link"
                                                                            size = "small"
                                                                            icon = buildElement { editOutlined {} }
                                                                            onClick = { onEdit(comment, item.id ?: "") }
                                                                        }
                                                                    }
                                                                }
                                                                props.onDeleteAnnotation?.let { onDelete ->
                                                                    button {
                                                                        attrs {
                                                                            type = "link"
                                                                            size = "small"
                                                                            icon = buildElement { deleteOutlined {} }
                                                                            onClick = { onDelete(comment, item.id ?: "") }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            // Show notes
                                            item.id?.let { contentId ->
                                                val itemNotes = notesMap[contentId]
                                                if (itemNotes != null && itemNotes.isNotEmpty()) {
                                                    div {
                                                        attrs.jsStyle = js {
                                                            marginTop = "12px"
                                                            paddingTop = "8px"
                                                            borderTop = "1px dashed #e8e8e8"
                                                        }
                                                        itemNotes.forEach { note ->
                                                            div {
                                                                attrs.jsStyle = js {
                                                                    marginBottom = "8px"
                                                                    padding = "8px"
                                                                    backgroundColor = "#fafafa"
                                                                    borderRadius = "4px"
                                                                    borderLeft = "3px solid #1890ff"
                                                                }
                                                                if (!note.title.isNullOrBlank()) {
                                                                    div {
                                                                        attrs.jsStyle = js {
                                                                            fontWeight = "bold"
                                                                            marginBottom = "4px"
                                                                            fontSize = "13px"
                                                                        }
                                                                        +note.title!!
                                                                    }
                                                                }
                                                                if (!note.comment.isNullOrBlank()) {
                                                                    div {
                                                                        attrs["dangerouslySetInnerHTML"] = js { __html = note.comment ?: "" }
                                                                        attrs.jsStyle = js {
                                                                            fontSize = "13px"
                                                                            lineHeight = "1.6"
                                                                        }
                                                                    }
                                                                }
                                                                if (!note.source.isNullOrBlank()) {
                                                                    div {
                                                                        attrs.jsStyle = js {
                                                                            fontSize = "12px"
                                                                            color = "#999"
                                                                            marginTop = "4px"
                                                                        }
                                                                        +"来源：${note.source}"
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            /*if(!comment.isNullOrBlank() && (commentContainsKey || !commentsInvisible.contains(item.id))) {
                                                if(commentContainsKey){
                                                    reactStringReplace(comment, props.keyword, { match, i-> buildElement { em { +match } } })
                                                }else{
                                                    +comment
                                                }
                                            }*/
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        modal{
            attrs{
                visible = showConnectModal
                title = "关联"
                onOk = ::onSaveConnection
                onCancel = {
                    setShowConnectModal(false)
                }
                closable = false
            }
            div{
                form {
                    row {
                        col {
                            attrs{
                                span = "24"
                            }
                            formItem {
                                attrs{
                                    label = "症状体征"
                                }

                                select<String, SelectComponent<String>> {
                                    attrs {
                                        showSearch = true
                                        ////mode = "multiple"
                                        ////labelInValue = false
                                        value = contentConnection.entityId
                                        placeholder = "选择症状"
                                        ////optionLabelProp = "label"
                                        filterOption = ::filterOptionFun
                                        onChange = { selected: String, option: dynamic ->
                                            console.log("select value",selected,option);
                                            val _contentConnection = Object.assign(ContentConnectionDto(),contentConnection)
                                            _contentConnection.entityId = selected
                                            _contentConnection.entityName = option.label
                                            setContentConnection(_contentConnection)
                                        }
                                        style = kotlinext.js.js { width = "100%" }
                                    }
                                    val editingConnectionId = contentConnection.id
                                    // 编辑时排除其他关联，不排除自身；新增时排除所有已关联
                                    val existingNames = currentContent.connections
                                        .firstOrNull { ContentConnectionEntityType.SignSymptom == it.entityType}
                                        ?.connectedEntities
                                        ?.filter { it.connectionId != editingConnectionId }
                                        ?.map { it.entityName }
                                        ?: listOf()
                                    props.signSymptoms.filter { !existingNames.contains(it.label) }.forEach { optGroup -> //要排除已经加的
                                        optGroup {
                                            attrs{
                                                label = "${optGroup.label}"
                                            }
                                            optGroup.children?.forEach { opt->
                                                option {
                                                    attrs{
                                                        label = "${opt.label}"
                                                        value = "${opt.value}"
                                                    }
                                                    +"${opt.label}"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            formItem {
                                attrs{
                                    label = "关系"
                                }
                                radioGroup {
                                    attrs {
                                        value = contentConnection.relationType?.getLiteral()
                                        onChange = { event: dynamic ->
                                            val _contentConnection = Object.assign(ContentConnectionDto(),contentConnection)
                                            _contentConnection.relationType = ContentConnectionRelationType.valueOf(event.target.value as String)
                                            setContentConnection(_contentConnection)
                                        }
                                        options = ContentConnectionRelationType.values().map { CascadedOption(it.getLiteral(), it.getLiteral()) }
                                            .toTypedArray().toJsObject()
                                    }
                                }
                            }
                            if (contentConnection.id != null) {
                                formItem {
                                    attrs {
                                        label = "删除关联"
                                    }
                                    switch {
                                        attrs {
                                            checked = contentConnection.isDeleted
                                            onChange = { checked, _ ->
                                                val _contentConnection = Object.assign(ContentConnectionDto(), contentConnection)
                                                _contentConnection.isDeleted = checked
                                                setContentConnection(_contentConnection)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        // Note Modal
        modal {
            attrs {
                title = if (editingNote != null) "编辑笔记" else "添加笔记"
                visible = showNoteModal
                maskClosable = false
                onCancel = {
                    if (!saving) {
                        destroyNoteEditor()
                        setSaveError(null)
                        setShowNoteModal(false)
                        setNoteForm(Comment())
                        setEditingNote(null)
                    }
                }
                onOk = {
                    saveNote()
                }
                okText = if (saving) "保存中..." else "保存"
                cancelText = "取消"
                okButtonProps = js {
                    loading = saving
                    disabled = saving
                }
                width = 720
            }

            form {
                attrs {
                    layout = "vertical"
                }

                if (saveError != null) {
                    div {
                        attrs.jsStyle = js {
                            color = "#ff4d4f"
                            backgroundColor = "#fff2f0"
                            border = "1px solid #ffccc7"
                            padding = "8px 12px"
                            marginBottom = "16px"
                            borderRadius = "4px"
                        }
                        +saveError!!
                    }
                }

                formItem {
                    attrs {
                        label = "笔记标题"
                    }
                    input {
                        attrs {
                            value = noteForm.title ?: ""
                            placeholder = "请填写笔记标题（可选）"
                            disabled = saving
                            onChange = { event: dynamic ->
                                val newTitle = event.target.value as String
                                setNoteForm { currentNote ->
                                    Object.assign(Comment(), currentNote).apply {
                                        title = newTitle
                                    }
                                }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "笔记内容"
                    }
                    div {
                        attrs.jsStyle = js {
                            border = "1px solid #d9d9d9"
                            borderRadius = "4px"
                            minHeight = "300px"
                        }
                        attrs["id"] = "note-editor-shanghanlun"
                    }
                }

                formItem {
                    attrs {
                        label = "来源"
                    }
                    input {
                        attrs {
                            value = noteForm.source ?: ""
                            placeholder = "请填写笔记来源（可选）"
                            disabled = saving
                            onChange = { event: dynamic ->
                                val newSource = event.target.value as String
                                setNoteForm { currentNote ->
                                    Object.assign(Comment(), currentNote).apply {
                                        source = newSource
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
